<script>
import ResourceService from '@/services/resources/allocation_units_service';
import SiteView from './SiteView.vue';

export default {
  extends: SiteView,
  components: {
    ActionBar: () => import('@/components/action_bars/AllocationUnitsActionBar.vue'),
  },
  data() {
    return {
      resourceService: ResourceService,
      icon: 'mdi-washing-machine',
      urlFragment: 'allocation-units',
      headers: [
        { text: 'Unit ID', value: 'id' },
        { text: 'Name', value: 'name' },
        { text: 'Last Dispense', value: 'lastDispenseTime' },
        { text: 'Last Sync', value: 'lastSyncTime' },
      ],
      sortBy: ['name'],
    };
  },
  computed: {
    resourceParams() {
      return {
        filter: {
          site: this.siteId,
        },
        fields: {
          'allocation-units': 'name,site,last-dispense-time,last-sync-time',
        },
      };
    },
  },
};
</script>
